module.exports = __webpack_public_path__ + "img/bgc_yunshu.png";